import { useMemo } from "react";

import { ICategory } from "web/types/Category";

const useUrlBack = (
  parentCategory: Partial<ICategory>,
  homePageData: Partial<ICategory>
) =>
  useMemo(() => {
    return parentCategory.request_path === homePageData.request_path
      ? parentCategory.request_path
      : `/${parentCategory.request_path}`;
  }, [parentCategory, homePageData]);

export default useUrlBack;
